var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-app-container"},[_c('Application',{staticClass:"test-class",attrs:{"id":"my-sub-app1","sandBox":{
      initialPath: '/sub-app1',
      disableFakeBody: true,
      disable: false
    },"manifest":"https://xuchangjunjx.github.io/sub-app1/my-sub-app1.manifest.json"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }